import type { NftView } from "../types";
import { tierName } from "../../../components/TierPortrait";

const referralNames: Record<number, string> = {
  50: "Trail Guide",
  100: "Grove Captain",
  500: "Sylvan Marshal",
};

export function nftLabel(nft: Pick<NftView, "tierUsd" | "artworkKind">): string {
  const tier = nft.tierUsd.toLocaleString("en-US");
  if (nft.artworkKind === "referral") return `Referral ${tier} · ${referralNames[nft.tierUsd] ?? "NFT"}`;
  if (nft.artworkKind === "task") return "Social task · Grove Herald";
  if (nft.artworkKind === "paid") return `Tier $${tier} · ${tierName(nft.tierUsd)}`;
  return `Tier ${tier} · NFT`;
}
